module.exports = __webpack_public_path__ + "media/p_ppair_win.276f2a64.mp3";